// extracted by mini-css-extract-plugin
module.exports = {"heroSectionWrapper":"ChartDataHeroSection_heroSectionWrapper__1248M","heroTextContainer":"ChartDataHeroSection_heroTextContainer__17MXz"};